var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"c-infinite-scroll"}},[_c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.infiniteHandler),expression:"infiniteHandler"}],attrs:{"infinite-scroll-distance":_vm.distance,"infinite-scroll-throttle-delay":_vm.throttleDelay}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }